module.exports = __webpack_public_path__ + "img/flat-foot.828bcc29.svg";